<div>
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
  </div>
  <div class="col-12">
    <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
    <p>{{ 'claimSection.lostPersonalItem.reportTheLoss.description' | translate}}</p>
  </div>
  <div class="col-12">
    <div class="col-lg-9 col-xl-8 col-md-12" style="padding-left:0" >
      <form>
        <div class="form-group">
          <qnect-ui #DMH_DISHONESTY_HELPER_INCIDENT_REPORT [fieldId]="'DMH_DISHONESTY_HELPER_INCIDENT_REPORT'" [formGroup]="reportTheLossForm" name="isIncidentReport"></qnect-ui>
        </div>
        <ng-container  *ngIf="this.policeReport.getHasReportedIncidentToPolice()">
          <div class="form-group">
            <qnect-ui #DMH_DISHONESTY_HELPER_NAME_ADDRESS [fieldId]="'DMH_DISHONESTY_HELPER_NAME_ADDRESS'" [formGroup]="reportTheLossForm" name="policeStationNameAndAddress"></qnect-ui>
          </div>
          <div class="form-group"> 
            <qnect-ui #DMH_DISHONESTY_HELPER_REFERENCE_NO [fieldId]="'DMH_DISHONESTY_HELPER_REFERENCE_NO'" [formGroup]="reportTheLossForm" name="referenceNumber"></qnect-ui>
          </div>
          <div class="form-group">
            <qnect-ui #DMH_DISHONESTY_HELPER_REPORT_DATE [fieldId]="'DMH_DISHONESTY_HELPER_REPORT_DATE'" [formGroup]="reportTheLossForm" [claimsDateValidator]="this.claim.getClaimHome().getDateOfIncident()" name="dateOfReport"></qnect-ui>
          </div>
        </ng-container>
      </form>

    </div>
    <div class="col-lg-4 col-md-12">
      &nbsp;
    </div>
  </div>

  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn new-btn btn-primary float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right" ></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
